import type { InputHTMLAttributes } from 'react'
import { formatMoneyInput, sanitizeMoneyInput } from '../lib/money'

interface MoneyInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'inputMode' | 'value' | 'onChange'> {
  value: string
  onValueChange: (value: string) => void
}

export function MoneyInput({ value, onValueChange, ...props }: MoneyInputProps) {
  return (
    <input
      {...props}
      type="text"
      inputMode="numeric"
      value={value === '0' ? '' : formatMoneyInput(value)}
      onChange={(event) => onValueChange(sanitizeMoneyInput(event.target.value) || '0')}
    />
  )
}
